module.exports = __webpack_public_path__ + "img/jptp@2x.251166d7.png";